// English-only UI strings.
export const translations = {
    en: {
        nav_home: "Home",
        nav_whoiam: "Who I Am",
        nav_casestudy: "Case Study",
        nav_consultation: "Consultation",
        nav_analyse: "Analyse",
        nav_workshop: "Workshops",
        nav_downloads: "Downloads",
        nav_shop: "Shop",
        nav_casestudies: "Case Studies",
        nav_blog: "Blog",
        nav_contact: "Contact",
        nav_blog: "Blog",
        nav_contact: "Contact",

        btn_book: "Book a Strategy Call",
        btn_book_paid: "Book Your Consultation",
        btn_analyse: "Book Your Consultation",
        btn_view_cases: "View Case Studies",
        btn_view_all_cases: "View All Case Studies",
        btn_view_all_blogs: "View All Blogs",
        btn_visit_linkedin: "Visit LinkedIn",

        home_hero_eyebrow: "Brand & Business Growth Consultant",
        home_hero_pre: "Build Your Business With",
        home_hero_c1: "Clarity",
        home_hero_c2: "Power",
        home_hero_amp: "&",
        home_hero_italic: "Growth Roadmap.",
        home_hero_sub:
            "I help entrepreneurs, startups, personal brands, and business owners find the right direction, strengthen their brand, fix growth gaps, and build a clear plan for the next 3 to 12 months.",
        home_founder_line:
            "Founder of Ragi Media · Brand Identity · Business Growth · Digital Advisor",
        home_brands: "Brands I Have Worked With",
        home_solve_eyebrow: "What I Help You Solve",
        home_stories_eyebrow: "Selected Success Stories",
        home_why_eyebrow: "Why Abhijit JK",
        home_words_eyebrow: "Client Words",
        home_latest_eyebrow: "Latest Blogs",
        home_offer_eyebrow: "Start Here",
        home_contact_eyebrow: "Get In Touch",
        home_contact_pre: "Have a question?",
        home_contact_gold: "Let's talk.",
        home_contact_body:
            "Tell me a little about your business and what you need. I'll get back to you personally.",

        about_eyebrow: "Who I Am",
        about_pre: "Meet",
        about_gold: "Abhijit JK",
        about_sub:
            "Abhijit JK is a Bengaluru-based Brand & Business Growth Consultant and Founder of Ragi Media. With 15+ years across branding, design, websites, UI/UX, and business visibility systems, he helps founders and growing companies build stronger positioning, better digital presence, and practical growth roadmaps.",

        consult_eyebrow: "1-on-1 Consultation",
        consult_pre: "1-Hour Business",
        consult_gold: "Consultation.",
        consult_sub:
            "In one focused 60-minute session, we cut the confusion and build a practical roadmap for your brand, your digital presence, and your next stage of growth. Available Monday to Friday — 8:00–9:00 AM and 9:00–10:00 AM.",

        cases_eyebrow: "Case Study",
        cases_pre: "Real Brand",
        cases_gold: "Growth Stories",
        cases_sub:
            "How strategy, design, websites, packaging, and digital systems helped real businesses become clearer, stronger, and more visible.",

        blog_eyebrow: "Blog",
        blog_pre: "Ideas on branding, growth &",
        blog_gold: "building visible brands.",
        blog_sub:
            "Straight, practical thinking for founders and business owners — no jargon, no fluff.",

        contact_eyebrow: "Contact",
        contact_pre: "Let's talk about your",
        contact_gold: "brand & growth.",
        contact_sub:
            "Have a question or want to discuss a project? Send a message and I'll get back to you.",

        booking_eyebrow: "Book Your Consultation",
        booking_pre: "Reserve your",
        booking_gold: "strategy session.",

        footer_explore: "Explore",
        footer_legal: "Legal",
        footer_contact: "Contact",
        footer_intro:
            "Helping founders and business owners build clear positioning, a strong brand, and a practical growth roadmap.",
    },
};
